import { WHATSAPP } from '../../constants';
import './finalcta.css';

function FinalCTA() {
  return (
    <section className="section finalcta">
      <div className="container">
        <div className="finalcta__content">
          <h2 className="finalcta__title">Empezá con un cambio simple: tu próxima limpieza puede ser más consciente</h2>
          <p className="finalcta__subtitle">
            Sin vueltas, sin compromiso. Escribinos y te contamos qué producto va con lo que necesitás.
          </p>
          <a href={WHATSAPP.url} target="_blank" rel="noreferrer" className="btn btn-whatsapp" style={{ fontSize: '1.1rem', padding: '16px 36px' }}>
            Quiero asesoramiento por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}

export default FinalCTA;
